import IntersectionObserverMixin from '@/components/Base/IntersectionObserverMixin';
import HyperlinkMixin from '@/components/Base/HyperlinkMixin';

export default {

    props: {
        items: { type: Array[Object] }
    },

    mixins: [ IntersectionObserverMixin, HyperlinkMixin ],

    data: function () {
        return {
            ready: true,
            error: null
        };
    },

    mounted: function () {
        this.initSection();
    },

    watch: {
        items: function () {
            this.initSection();
        }
    },

    methods: {
        initSection: function () {
            this.ready = (this.items && this.items.length);
        },

        getLocalizedSearchRoute: function (view, query = {}) {
            return this.getLocalizedRoute(view, this.$i18n.locale, query);
        }
    }
};
